export { default, HeadingLevel } from './Heading'
